import React from 'react';
import './FooterDirectories.css';

type Props = {
  topLevelFolders: string[];
  shortenName: (...args: any[]) => any;
};

const FooterDirectories = ({ topLevelFolders, shortenName }: Props) => (
  <div className="footer-directories">
    <div className="footer__title">Prefixes:</div>
    {topLevelFolders
      .filter((topLevelFolder) => topLevelFolder !== '')
      .map((topLevelFolder) => (
        <div className="footer__pill" key={topLevelFolder}>
          {topLevelFolder}
          <span>: </span>
          {shortenName(topLevelFolder)}
        </div>
      ))}
  </div>
);

export default FooterDirectories;
